<div class="row panel m-3">
    <div class="d-sm-flex justify-content-between w-100">
        <h4>Order Item(s)</h4>
        <p><a [routerLink]="['/shopping-cart']">Return to Shopping Cart</a></p>
    </div>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th class="text-left">Item</th>
                    <th class="text-center">Quantity</th>
                    <th class="text-right">Price</th>
                    <th class="text-right">Total</th>
                </tr>
            </thead>
            <tr
                class="text-left"
                *ngFor="let item of shoppingCart.shoppingCartItems"
            >
                <td class="">
                    {{item.productName}}
                    <p
                        *ngIf="item.description.length > 0"
                        [innerHtml]="item.description | safe:'html'"
                    ></p>
                    <p
                        *ngIf="item.originalPrice - item.price > 0"
                        class="saving"
                    >You saved {{item.originalPrice - item.price | currency : shoppingCart.currencyCode : ""}}</p>
                    <p
                        *ngFor="let promotion of item.promotions > 0"
                        class="saving"
                    >Promotion code <span style="font-weight:600;">{{promotion.code}}</span> was applied! {{promotion.description}}</p>
                </td>
                <td class="text-center">
                    {{item.quantity}}
                </td>
                <td class="text-right">
                    <div *ngIf="item.originalPrice - item.price > 0">
                        <s>{{item.originalPrice | currency : shoppingCart.currencyCode : ""}}</s>
                    </div>
                    <div [ngClass]="{'discount-price': item.originalPrice - item.price > 0}">
                        {{item.price | currency : shoppingCart.currencyCode : ""}}
                    </div>
                </td>
                <td class="text-right">
                    {{item.subTotal | currency : shoppingCart.currencyCode : ""}}
                </td>
            </tr>
            <tr
                *ngIf="shoppingCart.originalSubTotal - shoppingCart.subTotal > 0"
                class="text-right saving"
            >
                <td colspan="3">
                    Total savings
                </td>
                <td>
                    {{shoppingCart.originalSubTotal - shoppingCart.subTotal | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " "}}
                </td>
            </tr>
            <tr class="text-right">
                <td colspan="3">
                    Shipping And Handling Fee
                </td>
                <td class="text-right">
                    {{shoppingCart.shippingAndHandlingFee | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " "}}
                </td>
            </tr>
            <tr class="text-right">
                <td colspan="3">
                    <strong>Sub Total</strong>
                </td>
                <td>
                    <strong>{{shoppingCart.subTotal | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " "}}</strong>
                </td>
            </tr>
            <tr
                class="text-right"
                *ngFor="let tax of shoppingCart.taxes"
            >
                <td colspan="3">
                    {{tax.taxLabel}}
                </td>
                <td>
                    {{tax.taxAmount | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " "}}
                </td>
            </tr>
            <tr class="text-right">
                <td colspan="3">
                    <strong>Total</strong>
                </td>
                <td>
                    <strong>{{shoppingCart.total | currency : shoppingCart.currencyCode: shoppingCart.currencyCode + " "}}</strong>
                </td>
            </tr>
        </table>
    </div>
    <hr />
    <div class="d-md-flex w-100 mb-2">
        <h5>Discount/Promotion Code</h5>
        <div class="ml-md-5 ml-lg-auto">
            <label class="promotion-label">Please input discount/promotion code if you have one:</label>
            <input
                type="text"
                name="discountCode"
                class="mx-1"
                [(ngModel)]="discountCode"
            />
            <button
                (click)="applyDiscountCode()"
                class="btn btn-primary discount-btn"
            >Apply</button>
        </div>
    </div>
</div>
